import * as api from '@/http'

export const ActionSetScales = async ({ commit }) => {
  const scales = await api.http.get('dash/coordinator/scales').then((response) => response.data)
  commit('SET_scales', scales)
}

export const ActionSetEmployeeScales = async ({ commit }) => {
  const employee_scales = await api.http
    .get('dash/coordinator/employee/scales')
    .then((response) => response.data)
  commit('SET_employees_scales', employee_scales)
}

export const ActionCancelScale = async ({ commit }, scaleId) => {
  const scales = await api.http
    .put(`dash/scales/cancel/${scaleId}`)
    .then((response) => response.data)
  commit('SET_scales', scales)
}
export const ActionEditScale = async ({ commit }, scaleId) => {
  const { employee_scales, scales } = await api.http
    .put(`dash/scales/edit/${scaleId}`)
    .then((response) => response.data)
  commit('SET_employees_scales', employee_scales)
  commit('SET_scales', scales)
}
export const ActionFinishScale = async ({ commit }, scaleId) => {
  const scales = await api.http
    .put(`dash/scales/finish/${scaleId}`)
    .then((response) => response.data)
  commit('SET_scales', scales)
}

export const ActionSetScalesTypes = async ({ commit }) => {
  const scales_types = await api.http.get('dash/scales/types').then((response) => response.data)
  commit('SET_scales_types', scales_types)
}

export const ActionStoreScale = async ({ commit }, payload) => {
  const scales = await api.http.post('dash/scales', payload).then((response) => response.data)
  commit('SET_scales', scales)
}

export const ActionStoreEmployeeScale = async ({ commit }, payload) => {
  const { employee_scales, scales } = await api.http
    .post('dash/scales/employee', payload)
    .then((response) => response.data)
  commit('SET_employees_scales', employee_scales)
  commit('SET_scales', scales)
}

export const ActionDeleteEmploeeFromScale = async ({ commit }, payload) => {
  const { employee_id, scale_id } = payload
  const {
    employee_scales,
    scales,
  } = await api.http
    .delete(`dash/scales/employee/scale/${scale_id}`, { body: { employee_id } })
    .then((response) => response.data)
  commit('SET_employees_scales', employee_scales)
  commit('SET_scales', scales)
}

export const ActionDeleteEmployeeScaleDate = async ({ commit }, employee_scale_id) => {
  const employee_scales = await api.http
    .delete(`dash/scales/employee/date/${employee_scale_id}`)
    .then((response) => response.data)
  commit('SET_employees_scales', employee_scales)
}

export const ActionDeleteEmployeeScale = async ({ commit }, payload) => {
  const { employee_scales, scales } = await api.http
    .delete(`dash/scales/employee/${payload}`)
    .then((response) => response.data)

  commit('SET_employees_scales', employee_scales)
  commit('SET_scales', scales)
}

export const ActionStoreEmployeeScaleDate = async ({ commit }, payload) => {
  const employee_scales = await api.http
    .post(`dash/scales/employee/date`, payload)
    .then((response) => response.data)
  commit('SET_employees_scales', employee_scales)
}

export const ActionUpdateEmployeeScaleDate = async ({ commit }, payload) => {
  const { id } = payload
  const employee_scales = await api.http
    .put(`dash/scales/employee/date/${id}`, payload)
    .then((response) => response.data)
  commit('SET_employees_scales', employee_scales)
}

export const ActionUpdateEmployeeSchedule = async ({ commit }, payload) => {
  const { id } = payload
  const employee_scales = await api.http
    .put(`dash/scales/employee/schedule/${id}`, payload)
    .then((response) => response.data)
  commit('SET_employees_scales', employee_scales)
}

export const ActionSetSwaps = async ({ commit }) => {
  const swaps = await api.http
    .get('dash/coordinator/scales/swaps')
    .then((response) => response.data)
  commit('SET_swaps', swaps)
}

export const ActionApproveSwap = async ({ commit }, payload) => {
  const swaps = await api.http
    .post(`dash/coordinator/scales/swaps/approve/${payload.swap.id}`, payload)
    .then((response) => response.data)
  commit('SET_swaps', swaps)
}
export const ActionDownloadScalePDF = async ({}, id) => {
  const pdf = await api.http
    .post(
      `dash/scales/pdf/${id}`,
      {},
      {
        responseType: 'arraybuffer',
      }
    )
    .then((response) => {
      DownloadPdf(response.data)
    })
}

const DownloadPdf = (data) => {
  var out = new Blob([data], { type: 'application/pdf' })
  var _global =
    typeof window === 'object' && window.window === window
      ? window
      : typeof self === 'object' && self.self === self
      ? self
      : typeof global === 'object' && global.global === global
      ? global
      : this

  var force = out.type === 'application/octet-stream'
  var isSafari = /constructor/i.test(_global.HTMLElement) || _global.safari
  var isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent)
  var isMacOSWebView =
    /Macintosh/.test(navigator.userAgent) &&
    /AppleWebKit/.test(navigator.userAgent) &&
    !/Safari/.test(navigator.userAgent)

  if ((isChromeIOS || (force && isSafari) || isMacOSWebView) && typeof FileReader !== 'undefined') {
    // Safari doesn't allow downloading of blob URLs
    var reader = new FileReader()
    reader.onload = function (e) {
      window.location.href = reader.result
    }
    reader.readAsDataURL(out)
  } else {
    var URL = _global.URL || _global.webkitURL
    var url = URL.createObjectURL(out)
    location.href = url
    setTimeout(function () {
      URL.revokeObjectURL(url)
    }, 2000)
  }
}
